import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AppUiStore {
  // show the desktop header
  includeDesktopHeaderSubj = new BehaviorSubject<boolean>(false);
  includeDesktopHeader$ = this.includeDesktopHeaderSubj.asObservable();

  // show the appbar (mobile menu)
  appbarOpenSubj = new BehaviorSubject<boolean>(false);
  appbarOpen$ = this.appbarOpenSubj.asObservable();

  // show the nav and sidebar
  fullscreenSubj = new BehaviorSubject<boolean>(true);
  fullscreen$ = this.fullscreenSubj.asObservable();

  // add main content padding
  addMainContainerSpacingSubj = new BehaviorSubject<boolean>(true);
  addMainContainerSpacing$ = this.addMainContainerSpacingSubj.asObservable();

  removeNavOffsetSubj = new BehaviorSubject<boolean>(false);
  removeNavOffset$ = this.removeNavOffsetSubj.asObservable();

  // show the nav, but no sidebar
  appscreenSubj = new BehaviorSubject<boolean>(false);
  appscreen$ = this.appscreenSubj.asObservable();

  // use a narrow, centered container (setup)
  useNarrowCenteredSubj = new BehaviorSubject<boolean>(false);
  useNarrowCentered$ = this.useNarrowCenteredSubj.asObservable();

  // disable the max width on the content area
  stretchMainSubj = new BehaviorSubject<boolean>(false);
  stretchMain$ = this.stretchMainSubj.asObservable();

  // set width of main area to be wider to fit 2 columns on match builder dashboard
  matchBuilderDashboardSubj = new BehaviorSubject<boolean>(false);
  matchBuilderDashboard$ = this.matchBuilderDashboardSubj.asObservable();

  // set width of main area to be wider to fit 2 columns on care team dashboard
  careTeamDashboardSubj = new BehaviorSubject<boolean>(false);
  careTeamDashboard$ = this.careTeamDashboardSubj.asObservable();
}
